<template>
    <div :id="root">
        <ul class="list clearfix" :id="id">
            <item v-for="({title, description, image, url, data, type}, index) in cards" 
                :key="index" 
                :title="title"
                :description="description"    
                :image="image"
                :url="url"
                :data="data"
                :type="type"
            />
        </ul>
        <gl-pager
            v-if="pages > 1"
            :last="pages"
            @change="changePage"
        />
    </div>
</template>

<script>
import { is, isNil, hasIn, isEmpty } from 'ramda';

import GlPager from './groovielize/components/Paginator';
import Item from './components/Item';
import { TYPES } from './settings/Configs';

const LIMIT = hasIn('limit', window.list_data) && !isNil(window.list_data.limit)? window.list_data.limit : null;
const PAGER = hasIn('pager', window.list_data) && !isNil(window.list_data.pager)? window.list_data.pager : true;

export default {
  name: "List",
  props: {
    root: {
        type: String,
        required: true
    },
    id: {
        type: String,
        required: true
    },
    type: {
        type: String,
        required: true
    },
    baseUrl: {
        type: String,
        required: true
    },
    locale: {
        type: String,
        required: true
    }
  },
  data() {
      return {
          cards: [],
          pages: 0
      }
  },
  methods: {
      changePage(page) {
          this.getData(page);
      },
      getData(page = 1) {
          const uri = !isNil(window.list_data.url)? window.list_data.url : null;
          let url = `${uri}?locale=${this.locale}&page=${page}`;

          if (!isNil(LIMIT)) {
              url += `&limit=${LIMIT}`;
          }

          this.$groovie.get(url)
            .then(({data, total, last_page}) => {
                if (PAGER) {
                    this.$set(this, 'pages', last_page);
                }
                this.cards = data.map(({imgs, full_url, title, body, data, template, price}) => {
                    let image = null;
                    
                    if(!isNil(imgs) && is(Array, imgs) && !isEmpty(imgs)) {
                        image = imgs[0];
                        image = image.thumbnail.medium;
                    }

                    if(isNil(data)) {
                        data = {};
                    }

                    if(!isNil(price)) {
                        data.price = price;
                    }

                    if (template === 'product') {
                        body = '';
                    }

                    return {
                        title,
                        description: body,
                        image: `/storage/media/${image}`,
                        url: full_url,
                        data,
                        type: template
                    }
                });
            })
            .catch(error => console.error(error));
      }
  },
  created() {
      this.getData();
  },
  components: {
      Item,
      GlPager
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/List.vue